<template>
    <div class="game-intro-wrap m-0-a p-r">
        <div class="left-game-icon p-a">
            <img :src="info.game_icon" alt="">
        </div>
        <div class="right-game-intro">
            <div class="intro-item" v-for="(item,index) in info.list" :key="index">
                <span class="key d-i-b mb-f-s-l">【{{item.key}}】</span>
                <div class="value d-i-b" v-if="item.key == 'name'">
                    <p class="zh t-a-c mb-f-s-l">{{item.value_zh}}</p>
                    <p class="en t-a-c mb-f-s-l">{{item.value_en}}</p>
                </div>
                <span class="value t-a-c d-i-b mb-f-s-l" v-else>{{item.value}}</span>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .game-intro-wrap {
        width: 9.68rem;
        margin-bottom: 1.066667rem;
        .left-game-icon {
            width: 2.053333rem;
            height: 2.053333rem;
            top: 50%;
            left: 5%;
            margin-top: -1rem;
        }
        .right-game-intro {
            width: 100%;
            top: 0;
            left: 0;
            padding-left: 3rem;
            .intro-item {
                border-bottom: 1px dashed #73634c;
                padding-bottom: .1rem;
            }
            .key {
                width: 40%;
                text-indent: .133333rem;
            }
            .value {
                width: 60%;
                line-height: .4rem
            }
        }
    }
</style>

<script>
    export default {
        props: ['info']
    }
</script>



// WEBPACK FOOTER //
// client/smsgz/components/index/game-intro.vue